enum RequestStatus {
    CREATED = "CREATED",
    IN_PROGRESS = "IN_PROGRESS",
    OFFER_CREATED = "OFFER_CREATED",
    IN_DELIVERY_BY_COURIER = "IN_DELIVERY_BY_COURIER",
    IN_DELIVERY_BY_AGENT = "IN_DELIVERY_BY_AGENT",
    CLOSED = "CLOSED",
    ARCHIVED = "ARCHIVED"
}

export default RequestStatus;
